import { render, staticRenderFns } from "./CryptoProviders.vue?vue&type=template&id=34a0a8fa&"
import script from "./CryptoProviders.vue?vue&type=script&lang=js&"
export * from "./CryptoProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports